import { Typography } from '@material-ui/core';
import { FC } from 'react';
import { ReactComponent as LinkIcon } from '../../../Asset/svg/link.svg';
import { ReactComponent as UploadSimple } from '../../../Asset/svg/UploadSimple.svg';
import useStyles from './style';
import { VideoModalHeader } from './VideoModalShared';

type VideoImportChoiceModalProps = {
  onClose: () => void;
  enableYoutube: boolean;
  enableUpload: boolean;
  onSelectYoutube: () => void;
  onSelectUpload: () => void;
};

const VideoImportChoiceModal: FC<VideoImportChoiceModalProps> = ({
  onClose,
  enableYoutube,
  enableUpload,
  onSelectYoutube,
  onSelectUpload,
}) => {
  const classes = useStyles();
  return (
    <>
      <VideoModalHeader title="Importer une vidéo" onClose={onClose} />
      <Typography className={classes.videoModalSubtitle}>
        Choisissez comment vous souhaitez ajouter une vidéo :
      </Typography>
      <div className={classes.videoModalCards}>
        {enableYoutube && (
          <button type="button" className={classes.videoModalCard} onClick={onSelectYoutube}>
            <div className={classes.videoModalCardIconBlue}>
              <LinkIcon className={classes.videoModalCardIconLink} aria-hidden={true} />
            </div>
            <div className={classes.videoModalCardTexts}>
              <Typography className={classes.videoModalCardTitle}>URL YouTube</Typography>
              <Typography className={classes.videoModalCardDesc}>
                Ajouter un lien vers une vidéo Youtube
              </Typography>
            </div>
          </button>
        )}
        {enableUpload && (
          <button type="button" className={classes.videoModalCard} onClick={onSelectUpload}>
            <div className={classes.videoModalCardIconPurple}>
              <UploadSimple className={classes.videoModalCardIconUpload} aria-hidden={true} />
            </div>
            <div className={classes.videoModalCardTexts}>
              <Typography className={classes.videoModalCardTitle}>Uploader une vidéo</Typography>
              <Typography className={classes.videoModalCardDesc}>
                Importer une vidéo depuis votre appareil
              </Typography>
            </div>
          </button>
        )}
      </div>
    </>
  );
};

export default VideoImportChoiceModal;
